
export default {
	data() {
		return {
			options: {
				grid: true,
				values: this.values.map(val => {
					return val
				}),
				from: this.values.indexOf(this.value),
			}
		}
	},
	props: {
		text: String,
		values: Array,
		value: String,
		period: String,
	},
	methods: {
		changePeriod(value) {
			this.$emit('changePeriod', value)
		},
	}
}
